import React, { useRef, useState } from 'react';
import cn from 'classnames';

import styles from './FormControl.styles.scss';
import { Tooltip } from 'primereact/tooltip';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';

const FormControl = ({
  className,
  hasError,
  required,
  label,
  labelProps,
  tooltip,
  infoTitle,
  infoDetails,
  error,
  children,
  showError = true,
  freeInput,
  disabled,
  showTooltip,
}) => {
  const ref = useRef();
  const { t } = useTranslation();

  const [infoDialogOpen, setinfoDialogOpen] = useState(false);
  return (
    <div className={cn(styles.control, className)}>
      <Tooltip target={ref} showDelay="200" />

      {label ? (
        <p
          {...labelProps}
          className={cn(
            styles.label,
            { [styles.labelRequired]: required },
            labelProps?.className,
          )}
        >
          {typeof label === 'string' ? t(label) : label}
          {required && (
            <span aria-hidden="true" className={styles.requiredMark}>
              *
            </span>
          )}
          {tooltip && (!disabled || showTooltip) && (
            <i
              ref={ref}
              className="p-0 pi pi-info-circle"
              data-pr-tooltip={t(tooltip)}
            />
          )}
        </p>
      ) : null}
      {children}
      {showError && hasError && error && (
        <div
          className={cn(styles.error, { [styles.freeInputError]: freeInput })}
        >
          <span className={styles.errorText}>{error}</span>
        </div>
      )}
      <Dialog
        header={t(infoTitle)}
        visible={infoDialogOpen}
        style={{ width: '50vw', whiteSpace: 'pre-line' }}
        onHide={() => {
          if (!infoDialogOpen) {
            return;
          }
          setinfoDialogOpen(false);
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: t(infoDetails) }} />
      </Dialog>
    </div>
  );
};

export default React.memo(FormControl);
